import { render } from "./UIBlocker.vue?vue&type=template&id=5dd06f0a"
import script from "./UIBlocker.vue?vue&type=script&lang=js"
export * from "./UIBlocker.vue?vue&type=script&lang=js"

import "./UIBlocker.vue?vue&type=style&index=0&id=5dd06f0a&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__